<template>
    <modal name="item-auto-member-modal" class="member-mingle-update-modal"
           :width="`80%`"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div>
            <div class="modal_title">밍글 관리</div>
            <button class="close_btn" style="z-index: 99" @click="closeModal"></button>
            <member-list-component :memberType="`itemAuto`"></member-list-component>
        </div>
    </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import priceMixins from "@/mixins/priceMixins";
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
    name: "ItemAutoMemberModal",
    mixins: [priceMixins],
    components: {MemberListComponent},
    inject: [],
    provide() {
        return {
            selectData: this.selectData
        }
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
        },
        handlerBeforeClose() {
        },
        closeModal() {
            this.$modal.hide('item-auto-member-modal')
        },
        selectData(data) {
            let member = {key: data.mb_no, id: data.mb_id}
            let params = {no: data.mb_no, ip: 0}
            this.$api.$item.getCollect(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type === 1) {
                    EventBus.$emit('setSelectMember', member, res.List);
                    this.closeModal();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>